<section class="product-video" id="video">
  <!-- title -->
  <h3 class="product-video__title">{{ 'global.video' | translate }}</h3>
  <!-- video player -->
  <div class="product-video__content">
    <pwj-video-player
      [playBtnText]="(productVideo().title | translateData) || ''"
      [videoPreviewSrc]="
        productVideo()?.video?.url
          ? baseUrl + productVideo()?.video?.url
          : 'assets/images/mock-image/company-vision.jpg'
      "></pwj-video-player>
  </div>
</section>
